import {useMemo, useRef} from 'react'

import {useMatrixParamBuildContext} from '../contexts/MatrixParamBuildContext'
import {useMatrixParamBuildError} from '../contexts/MatrixParamBuildErrorContext'
import type {MatrixParamBuildParameter} from '../MatrixParamBuild.types'

function useMatrixParamBuildParameters() {
  const {deleteErrorMessageHandler} = useMatrixParamBuildError()
  const {
    parameters,
    restoreParameters,
    restoreParameterHandler,
    addParameterHandler,
    deleteParameterHandler,
    deletePermanentlyParameterHandler,
    parameterDuplicates,
    parameterSelectOptions,
    parameterSelectHints,
    parameterValuesOptions,
  } = useMatrixParamBuildContext()
  const latestInputParamNameRef = useRef<HTMLInputElement>(null)
  const isAllowDelete = useMemo(
    () => parameters.filter(parameter => !!parameter).length > 1,
    [parameters],
  )
  const clickAddParameterButtonHandler = () => {
    addParameterHandler()
    setTimeout(() => latestInputParamNameRef?.current?.focus(), 1)
  }
  const deleteParameterButtonClickHandler =
    (parameter: MatrixParamBuildParameter, index: number) => () => {
      deleteErrorMessageHandler(index)
      deleteParameterHandler(parameter, index)
    }
  const restoreParameterButtonClickHandler = (index: number) => () => restoreParameterHandler(index)
  const deletePermanentlyParameterButtonClickHandler = (index: number) => () =>
    deletePermanentlyParameterHandler(index)

  return {
    parameters,
    isAllowDelete,
    restoreParameters,
    parameterDuplicates,
    parameterSelectOptions,
    parameterValuesOptions,
    parameterSelectHints,
    latestInputParamNameRef,
    clickAddParameterButtonHandler,
    deleteParameterButtonClickHandler,
    restoreParameterButtonClickHandler,
    deletePermanentlyParameterButtonClickHandler,
  }
}

export default useMatrixParamBuildParameters
